export default {
  name: 'name',
  ticker: 'ticker',
  marketCapUsd: 'marketCapUsd',
  priceUsd: 'priceUsd',
  percentChange24h: 'percentChange24h',
  marketVol24h: 'marketVol24h',
};



// WEBPACK FOOTER //
// ./src/models/CurrenciesSortingFields.js